import React from 'react'
import { _ContentTitleWithMarginTop, Body1, H4, H5 } from './styles'
import { BackgroundContainer } from './styles'
import { ColorConf } from '@/config/color';
import { Typography, Box, styled } from '@mui/material';
import AuthButtons from './AuthButtons';

export const RegistrationWrapper = styled(Box)({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  backgroundColor: ColorConf.White,
  width: 230,
  padding: "24px 16px",
  borderRadius: 20,
  "@media (min-width: 600px)": {
    width: 400,
  }
});
const RegistrationStep = styled(Typography)({
  position: "absolute",
  display: "flex",
  alignItems: "center",
  top: -15,
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 15,
  fontWeight: 700,
  lineHeight: "20px",
  textTransform: "uppercase",
  color: ColorConf.HeroPrimaryColor,
});

const RegistrationSteps = () => {
  return (
    <BackgroundContainer
      sx={{
        gap: 2
      }}
    >
      <_ContentTitleWithMarginTop
        sx={{
          marginTop: 1,
          textShadow: ColorConf.HeroTitleTextShadow
        }}
      >
        登録の仕方
      </_ContentTitleWithMarginTop>
      <RegistrationWrapper>
        <RegistrationStep>
          Step <span style={{ fontSize: 19, lineHeight: "28px", fontWeight: 500, marginLeft: 6 }}>1</span>
        </RegistrationStep>
        <H4>
          プロフィールの入力
        </H4>
      </RegistrationWrapper>
      <img src="/images/hero-triangle.png" alt="triangle" style={{ width: 43, height: 22 }} />
      <RegistrationWrapper>
        <RegistrationStep>
          Step <span style={{ fontSize: 19, lineHeight: "28px", fontWeight: 500, marginLeft: 6 }}>2</span>
        </RegistrationStep>
        <img src="/images/hero-woman.png" alt="woman" style={{ width: 120, height: 120, position: "absolute", top: -75, left: -75, zIndex: -1 }} />
        <H4>
          本人確認
        </H4>
      </RegistrationWrapper>
      <img src="/images/hero-triangle.png" alt="triangle" style={{ width: 43, height: 22 }} />
      <RegistrationWrapper>
        <RegistrationStep>
          Step <span style={{ fontSize: 19, lineHeight: "28px", fontWeight: 500, marginLeft: 6 }}>3</span>
        </RegistrationStep>
        <img src="/images/hero-heart.png" alt="heart" style={{ width: 70, height: 50, position: "absolute", top: -15, right: -10 }} />
        <H4>
          利用開始
        </H4>
        <Body1 textAlign="center" sx={{ mt: `0 !important` }}>
          順次レコメンドが届きますので いいねしてご利用ください！
        </Body1>
      </RegistrationWrapper>
      <AuthButtons customStyles={{ position: "relative", marginBottom: -80, marginTop: 80 }} />
    </BackgroundContainer>
  )
}

export default RegistrationSteps